<template>
	<v-container class="ma-0" id="overviews" fluid >
		<v-card class="ma-0">
			<v-row style="width:100%" class="ma-0 ph-5">
				<v-col cols="12" sm="3">
					<v-card-title
						style="background:#eee;height:98px;border-bottom:1px solid #cecece;border-top-left-radius:4px;font-size:1.2rem;"
						class="pl-2 pb-3">
						<div class="mt-auto" style="display:flex;align-items:center;flex-direction:row;">
							<v-icon style="transform:rotate(90deg)">mdi-airplane</v-icon>
							<p style="color:rgba(0,0,0,.87)" class="mb-0 mt-auto pl-2 font-weight-bold">
								Crews
							</p>
						</div>
					</v-card-title>
					<v-treeview
						:items="get_combinedCrewsOnAirplane"
						style="max-height: calc(100vh - 251px); overflow-y: auto"
						v-on:update:active="onUpdate_CrewSelected"
						activatable
						:active="active_CombinedCrewsOnAirplane"
						color="primary"
						open-on-click
						transition>

						<template v-slot:prepend="{ item, open }">
							<v-icon v-if="!item.children">
								mdi-account-group
							</v-icon>
							<v-icon v-if="item.children && open" style="transform:rotate(180deg)">
								mdi-airplane
							</v-icon>
							<v-icon v-if="item.children && !open" style="transform:rotate(90deg)">
								mdi-airplane
							</v-icon>
						</template>

						<template v-slot:label="{ item }">
							<p class="ma-0" v-bind:class="{ 'custom-treeview-child-node': !item.children, 'custom-treeview-node': item.children }">
								{{ item.name }}
							</p>
						</template>

						<template v-slot:append="{ item }">
							<p v-if="item.children" style="font-size:1.3rem;font-weight:300;color:#ab3b7a;" class="ma-0">{{ item.children.length }}</p>
							<v-icon v-if="!item.children" @click.stop="onClick_CrewsOnAirplaneUpdate(item)">
								mdi-pencil
							</v-icon>
							<v-icon v-if="!item.children" class="ml-5" @click.stop="onClick_CrewsOnAirplaneRelocate(item)">
								mdi-account-switch
							</v-icon>
						</template>

					</v-treeview>
				</v-col>
				<v-col cols="12" sm="9">
					<v-data-table
						:items="get_MemberOnCrew.crew"
						:headers="headers"
						height="calc(100vh - 153px)"
						:fixed-header="true"
						:sort-by="['sortingIndex', 'fullName']"
						:sort-desc="false"
						group-by="idHrDepartmentFake"
						:group-desc="true"
						no-data-text="No crews available"
						:disable-pagination="true"
                        :hide-default-footer="true"
						style="border-top-right-radius:4px;">

						<template v-slot:group.header="{ group, headers, isOpen, toggle }">
							<td :colspan="headers.length" v-bind:class="{ 'custom-group-header-11': group === 'Cabin', 'custom-group-header-12': group === 'Cockpit' }">
								<div style="display:flex;align-items:center;justify-content:flex-start;" >
									<v-icon v-if="group === 'Cockpit'">mdi-shield-airplane</v-icon>
									<p v-if="group === 'Cockpit'" class="font-weight-bold ma-0 pl-2" style="font-size:1.2rem;">Cockpit</p>
									<p v-if="group === 'Cockpit'" class="ma-0 ml-auto" style="font-size:1.3rem;font-weight:300;color:#ab3b7a;">{{ get_MemberOnCrew.crew.filter(x => x.idHrDepartment === 12).length }}</p>

									<v-icon v-if="group === 'Cabin'">mdi-shield-airplane-outline</v-icon>
									<p v-if="group === 'Cabin'" class="font-weight-bold ma-0 pl-2" style="font-size:1.2rem;">Cabin</p>
									<p v-if="group === 'Cabin'" class="ma-0 ml-auto" style="font-size:1.3rem;font-weight:300;color:#ab3b7a;">{{ get_MemberOnCrew.crew.filter(x => x.idHrDepartment === 11).length }}</p>
								</div>
							</td>
						</template>

						<template v-slot:item.fullName="{ item }">
							<p class="ma-0 font-weight-bold">{{ item.fullName }} - {{ item.contract3Code }}</p>
						</template>

					</v-data-table>
				</v-col>
			</v-row>
		</v-card>

		<!-- >>> Floating 'Add' Button -->
		<v-speed-dial
			v-model="fab"
			fixed
			bottom
			right
			open-on-hover
			style="margin-bottom: 50px; margin-right: 50px;">

			<template v-slot:activator>
				<v-btn
					v-model="fab"
					color="primary"
					fab>

					<v-icon v-if="fab">
						mdi-close
					</v-icon>
					<v-icon v-else>
						mdi-plus
					</v-icon>
				</v-btn>
			</template>

			<v-btn
				fab
				small
				class="mr-6"
				@click="onClick_FloatingButton_MemberOnCrew()">
				<v-icon>
					mdi-account-group
				</v-icon>
			</v-btn>

			<v-btn
				fab
				small
				class="mr-6"
				@click="onClick_FloatingButton_CrewsOnAirplane()">
				<v-icon style="transform:rotate(90deg)">
					mdi-airplane
				</v-icon>
			</v-btn>

		</v-speed-dial>
		<!-- <<< Floating 'Add' Button -->

		<!-- >>> Sdr-Component, BottomSheet -->
		<sdr-crews-on-airplane-bottom-sheet
			v-model="showSheet_CrewsOnAirplane"
			:editorMode="editorMode_CrewsOnAirplane"
			:crewsOnAirplanePrefillObject="prefillObject_CrewsOnAirplane">
		</sdr-crews-on-airplane-bottom-sheet>
		<!-- <<< Sdr-Component, BottomSheet -->

		<sdr-member-on-crew-bottom-sheet
			v-model="showSheet_MemberOnCrew">
		</sdr-member-on-crew-bottom-sheet>

	</v-container>
</template>

<script>
	import Vue from 'vue';
	import { mapActions } from 'vuex';
	import { mapGetters } from 'vuex';

	import CrewsOnAirplaneBottomSheet from './components/core/BottomSheetCrewsOnAirplane.vue';
	import MemberOnCrewBottomSheet from './components/core/BottomSheetMemberOnCrew.vue';


	export default {
		name: 'CrewHome',


		/* >>> *************************************************************** / /* Components */
		components: {
			'sdr-crews-on-airplane-bottom-sheet': CrewsOnAirplaneBottomSheet,
			'sdr-member-on-crew-bottom-sheet': MemberOnCrewBottomSheet
		}, // eo components{}
		/* <<< ****************************************************************/


		/* >>> *************************************************************** / /* Data */
		data: function() {

			return {
				// >>> ------------------------------------ 'General'
				fab: false,
				selectedCrewId: null,
				// >>> ------------------------------------ 'Data Table'
				headers: [
					{ text: 'Name', value: 'fullName', class: 'sticky-header grey lighten-3' },
					{ text: 'Department', value: 'idHrDepartment', class: 'sticky-header grey lighten-3' },
					{ text: 'Position', value: 'contractFunction', class: 'sticky-header grey lighten-3' },
					{ text: 'Add Position', value: 'contractAddFunction', class: 'sticky-header grey lighten-3' }
				],
				// >>> ------------------------------------ 'Crews on Airplane'
				editorMode_CrewsOnAirplane: '',
				showSheet_CrewsOnAirplane: false,
				prefillObject_CrewsOnAirplane: null,
				// >>> ------------------------------------ 'Member on Crew'
				showSheet_MemberOnCrew: false,
				active_CombinedCrewsOnAirplane: []
			}

		}, // eo funCtion data()
		/* <<< ****************************************************************/


		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_combinedCrewsOnAirplane',
				'get_MemberOnCrew',
			]),

		}, // eo computed{}
		/* <<< ****************************************************************/


		/* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Load the 2 Department Calls in parallel.
        * Note: 'Cabin', 'Cockpit'
        *
        */
		created: function() {

            let me = this;


            me.$toc('>>> views/people/crews/Home.vue >>> created');
			this.actn_call_getCrewsOnAirplane();
			this.actn_call_crews_getResourcesOfDepartment({ department: '11', secondLoad: false });
			this.actn_call_crews_getResourcesOfDepartment({ department: '12', secondLoad: true });

		}, // eo function created()
		/* <<< ****************************************************************/


		/* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_call_getCrewsOnAirplane',
				'actn_call_getMemberOnCrew',
				'actn_call_crews_getResourcesOfDepartment',
				'actn_reset_crews_MemberOnCrew',
				'actn_sort_ResourcesOfDepartment'
			]),


            /******************************************************************* 'Listeners'
            * Listeners:
            *******************************************************************/
		    /*******************************************************************
			* onUpdate_CrewSelected()
			*
			* Desc: Trigger Call to get Crew Members.
			* Note: Only trigger if there is a Crew selected.
			*
			*/
			onUpdate_CrewSelected: function(obj) {

				let me = this;


				me.$toc('>>> views/people/crews/Home.vue >>> onUpdate_CrewSelected');
				if (obj.length > 0) {
					me.selectedCrewId = obj[0];
					me.actn_call_getMemberOnCrew(obj);
				}

				if (obj.length === 0) {
					me.selectedCrewId = null;
					me.active_CombinedCrewsOnAirplane = [];
					me.actn_reset_crews_MemberOnCrew();
				}

			}, // eo funciton onUpdate_CrewSelected()


			/*******************************************************************
			* onClick_CrewsOnAirplaneUpdate()
			*
			* Desc:
			*
			*/
			onClick_CrewsOnAirplaneUpdate: function(crew) {

				let me = this;


				me.$toc('>>> views/people/crews/Home.vue >>> onClick_CrewsOnAirplaneUpdate');
				me.active_CombinedCrewsOnAirplane.push(crew.id);
				this.prefillObject_CrewsOnAirplane = crew;

				this.editorMode_CrewsOnAirplane = 'update'; // set 'mode' & 'value
				this.showSheet_CrewsOnAirplane = true;

			}, // eo funciton onClick_CrewsOnAirplaneUpdate()


			/*******************************************************************
			* onClick_CrewsOnAirplaneRelocate()
			*
			* Desc:
			*
			*/
			onClick_CrewsOnAirplaneRelocate: function(crew) {

				let me = this;


				me.$toc('>>> views/people/crews/Home.vue >>> onClick_CrewsOnAirplaneRelocate');
				me.active_CombinedCrewsOnAirplane.push(crew.id);
				this.prefillObject_CrewsOnAirplane = crew;

				me.editorMode_CrewsOnAirplane = 'relocate'; // set 'mode' & 'value
				me.showSheet_CrewsOnAirplane = true;

			}, // eo funciton onClick_CrewsOnAirplaneRelocate()


			/*******************************************************************
			* onClick_FloatingButton_CrewsOnAirplane()
			*
			* Desc:
			*
			*/
            onClick_FloatingButton_CrewsOnAirplane: function() {

                let me = this;


				me.$toc('>>> views/people/crews/Home.vue >>> onClick_FloatingButton_CrewsOnAirplane');
				this.prefillObject_CrewsOnAirplane = null; // reset

				this.editorMode_CrewsOnAirplane = 'create'; // set 'mode' & 'value
				this.showSheet_CrewsOnAirplane = true;

			}, // eo function onClick_FloatingButton_CrewsOnAirplane()


			/*******************************************************************
			* onClick_FloatingButton_MemberOnCrew()
			*
			* Desc: Open Crew Bottom Sheet.
			* Note: Only if a crew is selected. (selectedCrewId is set)
			*
			*/
            onClick_FloatingButton_MemberOnCrew: function() {

                let me = this;


				me.$toc('>>> views/people/crews/Home.vue >>> onClick_FloatingButton_MemberOnCrew');
				if (me.selectedCrewId !== null) {
					// sort resources of department
                	me.actn_sort_ResourcesOfDepartment();

					me.showSheet_MemberOnCrew = true;
				}
				if(me.selectedCrewId === null) {
					Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Select a Crew'
                    });
				}

			}, // eo function onClick_FloatingButton_MemberOnCrew()

		} // eo methods{}
		/* <<< ****************************************************************/
	};
</script>

<style>
	/* .v-treeview .v-treeview-node:nth-of-type(2n) .v-treeview-node__root {
		background: #fafafa;
	} */

	.v-treeview-node.v-treeview-node--leaf .v-treeview-node__root {
		padding-left: 4px;
	}

	.custom-treeview-node {
		font-weight: 500;
	}

	.custom-treeview-child-node {
		font-weight: 300;
	}

	.custom-group-header-11 {
		border-left: 8px solid #8DD1E2;
	}

	.custom-group-header-12 {
		border-left: 8px solid #FEDE86;
	}

</style>